/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Delete_Terms_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to delete some terms: {error}" |
*
* @param {Knp_Terms_Delete_Terms_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_delete_terms_failed = /** @type {((inputs: Knp_Terms_Delete_Terms_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Delete_Terms_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la suppression de certains termes : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Einige Begriffe konnten nicht gelöscht werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare alcuni termini: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить некоторые термины: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron eliminar algunos términos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除某些术语失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`いくつかの用語を削除できませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कुछ शब्दों को हटाने में विफलता: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível excluir alguns termos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to delete some terms: ${i?.error}`)
});